import React, { FC } from 'react';
import { Forward, Gross, PickUpDetails } from 'ts/transfer/interfaces/TransferResultsResponse';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-regular-svg-icons';
import { getCurrency, formatPriceCurrency } from 'utils/utils';
import { faCar, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { dateFormat } from 'utils/transfer';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface TransferResultInfoSmProps {
  data: Forward;
  title: string;
  currency: keyof Gross;
}

const TransferResultInfoSm: FC<TransferResultInfoSmProps> = ({ data, title, currency }) => {
  const [t] = useTranslation();

  const getLocalle = (item: PickUpDetails) => {
    const locale = item.airport || item.city;
    return locale?.desc;
  };

  return (
    <div className="text-lh text-sm mb-20">
      <div className="title text-st mb-5">{t(title)}</div>
      <div className="flex">
        <div className="subtitle">{t('flight.date')}</div>
        <div>
          <FontAwesomeIcon icon={faCalendar as any} className="mr-5" />
          {dateFormat(data.transfer.pickUpDate + 'Z', 'dd MMM yyyy HH:mm')}
        </div>
      </div>
      <div className="flex">
        <div className="subtitle">{t('transfer.from')}</div>
        <div>
          <FontAwesomeIcon icon={faLocationDot} className="mr-5" />
          {getLocalle(data.transfer.pickUpDetails)}
        </div>
      </div>
      <div className="flex">
        <div className="subtitle">{t('transfer.to')}</div>
        <div>
          <FontAwesomeIcon icon={faLocationDot} className="mr-5" />
          {getLocalle(data.transfer.dropOffDetails)}
        </div>
      </div>
      <div className="flex">
        <div className="subtitle">{t('transfer.vehicle')}</div>
        <div>
          <FontAwesomeIcon icon={faCar} className="mr-5" />
          {data.transfer.transferVehicles.length && data.transfer.transferVehicles[0]?.vehicle.desc}
        </div>
      </div>
      <div className="flex">
        <div className="subtitle">{t('price')}</div>
        <div className="text-md text-bold">
          {data.transfer.transferVehicles.length &&
            formatPriceCurrency(
              data.transfer.transferVehicles[0]?.itemPrice.gross[currency] as number,
              getCurrency(currency)
            )}
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(TransferResultInfoSm, 'TransferResultInfoSm');
